export type PageStringsType = { [key: string]: string };

export const en: PageStringsType = {
  welcomeHeader: 'Welcome! Tell us a little bit about you.',
  helpUs: 'This will help us tailor your BugHerd experience.',
  error: 'These field(s) are required,'
};
